import script from "./ProductPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ProductPopup.vue?vue&type=style&index=0&id=6ab43166&lang=scss&scoped=true"

import exportComponent from "/srv/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab43166"]])

export default __exports__